import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungDUesseldorf() {
  return (
    <CityPageTemplate
      city="Düsseldorf"
      slug="duesseldorf"
      intro="Düsseldorf steht für Stil und Qualität – das gilt auch für Deine Finanzberatung."
      description="Unabhängige & digitale Finanzberatung für Düsseldorf: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
